const elemChildLinks = document.querySelectorAll('.ck24-articleInfo');
window.fireOnVisible(elemChildLinks, async (articleInfo) => {
    await import('./assets/css/wt-articleinfo.scss');
    if (articleInfo.querySelector('.share-article')) {
        await import('./assets/js/wt-articleInfo-sharing.ts');
    }
});
